import { cn } from "~/lib/utils";

import { Icon, LucideIconProps } from "../../icon";

export interface ToolbarButtonProps {
  icon: LucideIconProps;
  onClick?: () => void;
  isActive?: boolean;
  onMouseDown?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

const ToolbarButton = ({
  icon,
  onClick,
  isActive,
  onMouseDown,
  className,
}: ToolbarButtonProps) => {
  return (
    <button
      onMouseDown={onMouseDown}
      type="button"
      onClick={onClick}
      className={cn(
        "flex h-7 min-w-7 items-center justify-center rounded-sm text-sm hover:bg-neutral-200/80",
        {
          "bg-neutral-200/80": isActive,
        },
      )}
    >
      <Icon name={icon} className={cn("size-5 text-primary-600", className)} />
    </button>
  );
};

export default ToolbarButton;
